import { render, staticRenderFns } from "./SocialTrafficTable.vue?vue&type=template&id=ec95a85e"
import script from "./SocialTrafficTable.vue?vue&type=script&lang=js"
export * from "./SocialTrafficTable.vue?vue&type=script&lang=js"
import style0 from "./SocialTrafficTable.vue?vue&type=style&index=0&id=ec95a85e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports